import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { TotemWidget } from '../totem-widget';

@Component({
    selector: 'app-totem-widget-imagelist',
    templateUrl: './totem-widget-imagelist.component.html',
    styleUrls: ['./totem-widget-imagelist.component.scss'],
    standalone: false
})
export class TotemWidgetImagelistComponent extends TotemWidget {

    size:'lg' = 'lg'

    @Input() imageList:Array<{ file: string, text: string, author: string }>;
    @Input() verticalList:boolean;

    currentIndex = 0;

    @ViewChild('scrollContainer') scrollContainer:ElementRef;

    hasInactiveFlip = true;

    onInactiveFlip() {
        let _element = this.scrollContainer.nativeElement as HTMLDivElement;

        let _scrollTo = 0;

        if(_element.scrollTop < _element.scrollHeight - _element.offsetHeight) {
            let _childHeight = _element.children[0].children[0].scrollHeight;
            let _childStep = Math.floor(_element.offsetHeight / _childHeight);
            let _remainder = _element.offsetHeight % _childHeight;

            let _partialTop = (_element.scrollTop % _childHeight)
            if(_partialTop > 0) {
                _scrollTo = _element.scrollTop - _partialTop;
                _childStep++;
            }
            
            _scrollTo += (_childStep * _childHeight) - _remainder * 0.5;
        }

        _element.scrollTo({ top: _scrollTo, behavior: 'smooth' })
    }
}
